import React, { Component } from 'react';

class FacebookIcon extends Component {


    render() {

        let width = this.props.width || "25px";
        let height = this.props.height || "24px";

        return (
            <svg width={width} height={height} viewBox="0 0 25 24" version="1.1" xmlSpace="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink">
                <title>Facebook</title>
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g id="Homepage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Homepage-3" transform="translate(-548.000000, -2814.000000)" fill="#3B5998">
                            <g id="Section-5" transform="translate(0.000000, 2650.000000)">
                                <g id="Facebook-+-Share" transform="translate(517.000000, 156.000000)">
                                    <g transform="translate(31.000000, 8.000000)" id="Facebook">
                                        <path d="M24.3454733,1.5 C24.3454733,0.6796875 23.6657858,0 22.8454733,0 L1.84547335,0 C1.02516085,0 0.345473346,0.6796875 0.345473346,1.5 L0.345473346,22.5 C0.345473346,23.3203125 1.02516085,24 1.84547335,24 L13.1775046,24 L13.1775046,14.671875 L10.1775046,14.671875 L10.1775046,11.2148438 L13.1775046,11.2148438 L13.1775046,8.2265625 C13.1775046,5.49609375 14.8415671,3.66796875 18.1345358,3.66796875 C19.5876608,3.66796875 20.5954733,3.83203125 20.5954733,3.83203125 L20.5954733,6.94921875 L18.3454733,6.94921875 C17.3493796,6.94921875 16.8454733,7.51171875 16.8454733,8.49609375 L16.8454733,11.2148438 L20.3493796,11.2148438 L19.8454733,14.671875 L16.8454733,14.671875 L16.8454733,24 L22.8454733,24 C23.6657858,24 24.3454733,23.3203125 24.3454733,22.5 L24.3454733,1.5 Z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
            </svg>
        );
    }

}

export default FacebookIcon
